import { useState, useCallback } from 'react';
import {
  ActionPlanFlowManager,
  type ActionPlanChoices,
  type ActionPlanFlowState,
} from '../logic/ActionPlanFlowManager';

export interface UseActionPlanFlowResult {
  currentStep: ActionPlanFlowState['currentStep'];
  selectedCategoryId: ActionPlanFlowState['selectedCategoryId'];
  submittedChoices: ActionPlanFlowState['submittedChoices'];
  handleFocusContinue: (categoryId: number) => void;
  handleSelectionSuccess: (choices?: ActionPlanChoices) => void;
  handleSelectionBack: () => void;
}

export function useActionPlanFlow(): UseActionPlanFlowResult {
  const [flowState, setFlowState] = useState<ActionPlanFlowState>(() =>
    ActionPlanFlowManager.getInitialState()
  );

  const handleFocusContinue = useCallback((categoryId: number) => {
    setFlowState(state => ActionPlanFlowManager.handleFocusContinue(state, categoryId));
  }, []);

  const handleSelectionSuccess = useCallback((choices?: ActionPlanChoices) => {
    setFlowState(state => ActionPlanFlowManager.handleSelectionSuccess(state, choices));
  }, []);

  const handleSelectionBack = useCallback(() => {
    setFlowState(state => ActionPlanFlowManager.handleSelectionBack(state));
  }, []);

  return {
    currentStep: flowState.currentStep,
    selectedCategoryId: flowState.selectedCategoryId,
    submittedChoices: flowState.submittedChoices,
    handleFocusContinue,
    handleSelectionSuccess,
    handleSelectionBack,
  };
}
